/* import __COLOCATED_TEMPLATE__ from './manager.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { needsToReverifySecureContact } from '../menu/base';
export const METHODS_TO_ENROLL = Object.freeze({
  PHONE: 'PHONE',
  EMAIL: 'EMAIL'
});
let SecureContactModalManagerComponent = (_dec = service('ember-multipassfe-client'), _class = class SecureContactModalManagerComponent extends Component {
  // fn to be called after re-verifying secure contact

  get phoneDetails() {
    return this.multipassfeClient.secureContactDetails?.filter(x => x.phone) || [];
  }
  get emailDetails() {
    return this.multipassfeClient.secureContactDetails?.filter(x => x.email) || [];
  }
  get hasPhone() {
    return this.phoneDetails.length > 0;
  }
  get hasEmail() {
    return this.emailDetails.length > 0;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _defineProperty(this, "methodsToEnroll", METHODS_TO_ENROLL);
    _initializerDefineProperty(this, "enrollModalOpen", _descriptor2, this);
    _initializerDefineProperty(this, "methodToEnroll", _descriptor3, this);
    _initializerDefineProperty(this, "detailToBeUpdated", _descriptor4, this);
    _initializerDefineProperty(this, "detailToBeVerified", _descriptor5, this);
    _initializerDefineProperty(this, "refreshSecureContactModalOpen", _descriptor6, this);
    _initializerDefineProperty(this, "refreshSecureContactCallback", _descriptor7, this);
  }
  handleRefreshSecureContactModalOpen() {
    this.refreshSecureContactModalOpen = true;
  }
  handleEnrollModalOpen() {
    this.enrollModalOpen = true;
  }
  handleEnrollModalClose() {
    this.enrollModalOpen = false;
    this.detailToBeVerified = undefined;
    this.detailToBeUpdated = undefined;
  }
  handleEnrollPhone() {
    this.methodToEnroll = this.methodsToEnroll.PHONE;
    const reverifyCandidate = this.hasEmail ? this.emailDetails[0] : undefined;
    if (reverifyCandidate && needsToReverifySecureContact(reverifyCandidate)) {
      this.detailToBeVerified = reverifyCandidate;
    }
    this.handleEnrollModalOpen();
  }
  handleEnrollEmail() {
    this.methodToEnroll = this.methodsToEnroll.EMAIL;
    const reverifyCandidate = this.hasPhone ? this.phoneDetails[0] : undefined;
    if (reverifyCandidate && needsToReverifySecureContact(reverifyCandidate)) {
      this.detailToBeVerified = reverifyCandidate;
    }
    this.handleEnrollModalOpen();
  }
  handleUpdateDetail(detail) {
    this.detailToBeUpdated = detail;
    this.methodToEnroll = detail.phone ? this.methodsToEnroll.PHONE : this.methodsToEnroll.EMAIL;
    if (needsToReverifySecureContact(detail)) {
      this.detailToBeVerified = detail;
    }
    this.handleEnrollModalOpen();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "enrollModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "methodToEnroll", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methodsToEnroll.PHONE;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "detailToBeUpdated", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "detailToBeVerified", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "refreshSecureContactModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "refreshSecureContactCallback", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleRefreshSecureContactModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRefreshSecureContactModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEnrollEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEnrollEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdateDetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdateDetail"), _class.prototype), _class);
export { SecureContactModalManagerComponent as default };